import createSelector from 'lib/web/createSelector'

export const shouldShowMagazineArticle = createSelector(
  (state: App.State) => state.content.magazineArticles,
  (magazineArticles: App.ContentMagazineArticlesState): boolean => magazineArticles.posts.length >= 2,
)
